import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';
import { layers } from '@atlassian/jira-common-styles/src/main.tsx';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

const Bold = ({ children }: { children: ReactNode }) => <b>{children}</b>;

export const EnableOutgoingMailInfo = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const siteUrl = window.location.hostname;
	const { formatMessage } = useIntl();
	return (
		<OutgoingMailErrorText>
			<ErrorIcon
				LEGACY_size="medium"
				spacing="spacious"
				label=""
				color={token('color.icon.danger')}
			/>
			<FormattedI18nMessage
				message={formatMessage(messages.configDisabledAndHasFailureLogs, {
					boldStart: '{boldStart}',
					boldEnd: '{boldEnd}',
					siteUrl,
				})}
				componentsMapping={{ bold: Bold }}
			/>
		</OutgoingMailErrorText>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OutgoingMailErrorText = styled.div({
	paddingTop: token('space.150'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.150'),
	paddingLeft: 0,
	display: 'inline-block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		position: 'relative',
		top: token('space.075'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: { bottom: token('space.075') },
	top: 0,
	position: 'sticky',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layers.dialog,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface'),
	width: '100%',
});
